<template>
  <div class="mit-calendar-multi-spaces" style=""><!-- default all to 1 but override sm and larger to 8 -->
        <v-row class="mb-0 pb-0 pt-3 mb-1">
                <slot name="filterPre"></slot>
                <v-spacer/> 
                    <v-menu bottom >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="filterSpaceTypes.length > 0" outlined text class="ma-1 mr-2 pr-1" v-bind="attrs" v-on="on" color="primary"> Filters ({{ filterSpaceTypes.length }})<v-icon>mdi-menu-down</v-icon></v-btn>
                            <v-btn v-else class="ma-1 mr-1" color="primary" outlined text v-bind="attrs" v-on="on">Filters<v-icon>mdi-menu-down</v-icon></v-btn>
                        </template>
                        
                        <v-list>
                        <v-list-item v-for="(item, index) in spaceInfo.types" :key="index" @click.stop>
                            <v-list-item-action>
                                <v-checkbox @click.stop v-model="filterSpaceTypes" :value="item" hide-details></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        </v-list>

                    </v-menu>
                    <v-text-field class="pa-0 ma-0 pt-1 pl-3 pr-5" style="max-width:200px" clearable v-model="spaceSearch" label="Find Space" hide-details prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-row>
        
        <v-row> 
            <slot name="filterErrors"></slot>
       </v-row>
      <v-row>
            <v-sheet style="overflow:auto; height:calc(100vh - 245px)">
                <!--  -->
                <v-calendar
                    class="mit-calendar"
                    ref="calMulti"
                    type="category"
                    v-model="calendarValue"
                    :events="events"
                    color="primary"
                    category-show-all
                    category-text="mitId"
                    :categories="filteredSpaces"
                    @click:time-category="calClickTimeCat"
                    @click:event="clickedExistingReservation"
                    @touchend:interval="calTouchInterval"
                    >
                    <template v-slot:day-body="{ date, week }">
                        <div
                            class="v-current-time"
                            :class="{ first: date === week[0].date }"
                            :style="{ top: nowY }"
                        ></div>
                    </template>
                    <template v-slot:event="{ event }">
                        <!-- <v-card flat max-width="120px"> -->
                            <!-- <div><b>{{  event.reservationModel.startTime1 }} - {{ event.reservationModel.endTime1 }}</b></div>
                            <div>{{ event.reservationModel.name }}</div> -->
                            <!-- <div :class="event.potential ? 'potential-event' : 'existing-event'"> -->
                            <div v-if="event.potential" class="potential-event">
                                <div class="pl-2 pr-2" @click="$emit('create')">
                                        <div class="black--text text-truncate"><b>{{  event.reservationModel.startTime1 }} - {{ event.reservationModel.endTime1 }}</b></div>
                                        <div>&nbsp;</div>
                                </div>
                            </div>
                            <div v-else class="existing-event" style="position: relative; height: 100%;width: 100%;">
                                <div class="pl-2 pr-2" style="position: relative;  height: 100%;width: 100%; overflow: clip;">
                                        <div class="black--text text-truncate" style=""><b>{{ event.reservationModel.name  }}</b></div>
                                        <div class="black--text text-truncate" style="">{{  event.reservationModel.startTime1 }} - {{ event.reservationModel.endTime1 }}</div>
                                </div>
                            </div>
                        <!-- </v-card> -->
                    </template>
                    <template v-slot:category="{ category }">
                        <v-card flat class="" :max-width="calendarSpaceWidth(category)">
                            <v-card @click="clickedSpaceInfo(category)" flat class="white--text align-end" color="grey darken-4" height="80px" style="min-width:198px">
                                <v-card-title class="pt-0 pb-0 mt-0 mb-0">
                                        <!-- {{category.name}} -->
                                        <h5 class="pt-1 pb-0 mt-0 mb-0" style="line-height:1.5rem">
                                            <!-- {{category.mitId}} -->
                                            <!-- {{category.nameFormatted}} -->
                                            {{category.name}}
                                        </h5>
                                        <v-spacer/>
                                        <v-tooltip bottom color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-if="isPrivateSpace(category)"v-bind="attrs" v-on="on" small color="white">mdi-lock</v-icon>
                                            </template>
                                            <span>This space or object is private and only available to designated CSAIL members</span>
                                        </v-tooltip>
                                        
                                        <!-- <v-icon class="pt-0" color="grey darken-1">mdi-information-outline</v-icon> -->
                                       
                                </v-card-title>
                                <v-card-subtitle v-if="category.spaceType == 'object'" class="body-2 white--text pa-0 pl-4 pt-4"> {{category.containingSpace}} </v-card-subtitle>
                                <v-card-subtitle v-if="category.spaceType == 'space' && category.name != category.mitId" class="body-2 white--text pa-0 pl-4 pt-4"> {{category.mitId}} </v-card-subtitle>
                                <!-- <v-card-subtitle class="body-2 white--text pa-0 pl-4">{{category.useType.split(' ')[0]}}</v-card-subtitle> -->
                                <!-- <p style="" class="font-weight-thin white--text mt-0 pa-0 pl-4">{{category.useType.split(' ')[0].toLowerCase()}}</p> -->
                            </v-card>

                            <v-card-actions class="pa-0">

                            <!-- for unknown reasons, I the UI is not detecting changes and updating if i manipulate the category itself, even though it is a space... -->
                            <v-btn v-if="spacesDict[category.mitId].favorite === true" @click="spaceFavoriteClick(spacesDict[category.mitId])" icon>
                                <v-icon  color="red lighten-1">mdi-heart</v-icon>
                            </v-btn>
                            <v-tooltip v-else color="primary" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="" @click="spaceFavoriteClick(spacesDict[category.mitId])" icon v-bind="attrs" v-on="on"><v-icon>mdi-heart-outline</v-icon></v-btn>
                                </template>
                                <span>Favorite a space. <br>Favorites show first in the list and also display on your dashboard!</span>
                            </v-tooltip>

                            <v-tooltip bottom color="primary" v-if="category.maxCapacity">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                                        <v-badge overlap color="grey lighten-1" :content="category.maxCapacity" right top>
                                            <v-icon>mdi-account-multiple-outline</v-icon>
                                        </v-badge>
                                    </v-btn>
                                </template>
                                <span>Seating Capacity: <b>{{category.maxCapacity}}</b><br>{{category.seating}}</span>
                            </v-tooltip>
                            <!-- <v-tooltip max-width="400px" bottom color="black" v-if="category.equipment">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-2" icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-television</v-icon>
                                    </v-btn>
                                </template>
                                <span> <b>Equipment:</b><br>{{category.equipment}}</span>
                            </v-tooltip> -->
                            <v-btn v-if="category.images && category.images.length > 0" class="" icon @click="clickedImages(category)">
                                <v-icon>mdi-image-multiple</v-icon>
                            </v-btn>
                            <!-- <v-icon v-else color="grey">mdi-image-multiple</v-icon> -->
                            <!-- <v-tooltip bottom color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-2" icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-wrench-outline</v-icon>
                                    </v-btn>
                                </template>
                                <div class="text-h5 mb-1">Equipment</div>
                                <v-list color="transparent" one-line>
                                    <v-list-item class="pa-0 ma-0" v-for="e in category.equipment" :key="e.name">
                                        <v-list-item-avatar class="pa-0 ma-0">
                                            <v-icon class="pa-0 ma-0">mdi-wrench-outline</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content class="pa-0 ma-0 white--text">
                                            <v-list-item-title class="pa-0 ma-0">
                                                <b>{{e.name}}</b>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="pa-0 ma-0 white--text">{{e.description}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </v-list>
                            </v-tooltip> -->
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-calendar>
            </v-sheet>
        </v-row>
  </div>
</template>

<script>
  import moment from 'moment';
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';

export default {
  name: 'MitCalendarMultiSpaces',
  components: {
  },
  props: {
      userModel:{
          default () {
              return null;
          },
          type: Object
      },
      height:{
          default () {
              return 400;
          },
          type: Number
      },
      defaultCategory:{
          default () {
              return null;
          },
          type: String
      },
      calendarType:{
          default () {
              return 'day';
          },
          type: String
      },
      events: Array,
      // focusTime:{
      //     default () {
      //         return moment().format('hh:mm A');
      //     },
      //     type: String
      // },
      calendarDate:{
          default () {
              return moment().format('YYYY-MM-DD');
          },
          type: String
      },
      spacesList:{
          default () {
              return [];
          },
          type: Array
      },
      spaceInfo:{
          default () {
              return {};
          },
          type: Object
      }

  },
  data: function() {
    return {
        ui:{
            searchExpand:false,
            filterExpand:false,
            sortExpand:false
        },
        showCalendarSpaceId:null,
        selectedSpace:null,
        spaceShowCalendar:null,
        filterCapacity:0,
        filterSpaceBuilding:null,
        filterSpaceFloor:null,
        filterSpaceTypes:['CONFERENCE ROOM', 'SEMINAR ROOM', 'RESEARCH LAB', 'OFFICE', 'LOUNGE', 'FOOD FACILITY'],
        spacesUrl:null,
        spacesDict:{},
        spaceTypes:[{text:'Conference Room',id:'conference'},{text:'Phonebooth',id:'phonebooth'}],
        spacesEquipment:[],
        spaceSearch:'',
        mounted:false,
        calendarValue:null,
        time:null
    }
  },
  watch: {
      // focusTime(newVal, oldVal) {
      //     this.time = moment(newVal, 'hh:mm A');
      // },
      calendarDate(newVal, oldVal) {
          this.calendarValue = moment(newVal, 'YYYY-MM-DD').toDate();
      }
  },
  computed: {
      getView () {
        if(this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm')
            // return 'mobile-list'
            //for now just show calendar view, its better than before
            return 'desktop'

        if(this.$vuetify.breakpoint.name === 'md' || this.$vuetify.breakpoint.name === 'lg')
            // return 'mobile-calendar'
            return 'desktop'

        return 'desktop'
      },
      filteredSpaces() {
          let allow;
          return this.spacesList.filter((x) => {
                allow = true;

                if(this.filterSpaceTypes.length > 0 && this.filterSpaceTypes.includes(x.useType) == false){
                    allow = false;
                }
                if(this.filterSpaceFloor && x.level != this.filterSpaceFloor){
                    allow = false;
                }
                if(this.filterSpaceBuilding  && x.buildingMitId != this.filterSpaceBuilding ){
                    allow = false;
                }
                if(this.spaceSearch && this.spaceSearch.length > 0 && (x.mitId.indexOf( this.spaceSearch) < 0 && x.name.indexOf( this.spaceSearch) < 0)){
                    allow = false;
                }
                return  allow;
            }
          );
      },
      cal () {
        return this.mounted ? this.$refs.calMulti : null
      },
      nowY () {
        return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
      },
  },
  created() {
    this.createSpacesDict();
  },
  mounted() {
      this.mounted = true;
      this.setFocusTimeNow();
      this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');
  },
  methods : {
    calendarSpaceWidth(category){
        if(category.spaceType === 'object')
            return '300px';
        else 
            return '120px';
    },
    isPrivateSpace(space){
        return space.accessIds.length > 0 && space.accessIds.indexOf(this.userModel.csailId);
    },
    clickedExistingReservation(clickEvent){
        clickEvent.nativeEvent.stopPropagation();
        if(clickEvent.event.reservationModel && clickEvent.event.reservationModel.id){
            this.$emit('showExistingReservationDetails', clickEvent.event.reservationModel);
        }
        
    },
    clickCreate(space){
        this.$emit('create', space);
    },
    clickedShowCalendar(space){
        if(this.spaceShowCalendar == space.id){
            this.spaceShowCalendar = null;
        }
        else{
            this.spaceShowCalendar = space.id
        }
    },
    clickedImages(space){
        this.$emit('showSpaceImages', space);
    },
    clickedSpaceInfo(space){
        this.$emit('showSpaceDetails', space);
    },
    createSpacesDict(spaces){
        for(let x = 0; x < this.spacesList.length; x++){
            this.spacesDict[this.spacesList[x].mitId] = this.spacesList[x];
        }
    },
      spaceFavoriteClick(space){
        this.$emit('favoriteChanged', space);
      },
      setFocusTimeNow(){
          this.setFocus(moment())
      },
      setFocusTimeString(time){
          this.setFocus(moment(this.calendarDate + ' ' + time, 'YYYY-MM-DD hh:mm A' ))
      },
      setFocus(momentTime) {
          if(this.cal){
            //HACK ALERT - for calendar in category time only.
            //OMG, this is a hack because scrollToTime doesn't work for the calendar category view which is sort of terrible
            const y = this.cal.timeToY(momentTime.format("HH:mm"));
            if (y === false || !this.cal.$el) {
                return false;
            }
            this.cal.$el.scrollTop = y-200; //This is needed to offset the category card header. Could probably get this programatically
            !!this.cal.$el.scrollTop;
          }
          
      },
      calClickTimeCat(obj){

          //get a moment version of start time
          let eventDate = moment(this.calendarDate, 'YYYY-MM-DD');
          eventDate.set({hour:obj.hour,minute:obj.minute});

          //round to the nearest half hour
          let startTime = eventDate.add( 30 - eventDate.minute() % 30, 'm');
          startTime.subtract(30, 'm');

          let updated = {
              mitId:obj.category.mitId,
              date:startTime.format('YYYY-MM-DD'),
              time:startTime.format('hh:mm A'),
              datetimeMoment:startTime
          };

          this.$emit('change', updated);

      },
      calTouchInterval(obj){
          console.log('calTouchInterval', obj);
      }
  }
}
</script>

<style lang="scss" scoped>
   ::v-deep .v-calendar-category__column-header{
        min-width:200px !important;
        // display:inline-block !important;
        // width: max-content !important;
        // min-width:max-content !important;
    }

    ::v-deep .v-calendar-daily__day{
        min-width:200px !important;
        // display:inline-block !important;
        // width: max-content !important;
        // min-width: max-content !important;
    }
    
    
    
    
    // ::v-deep .v-calendar-daily__day{
    //     // min-width:120px !important;
    //     // display:inline-block !important;
    //     width: max-content !important;
    //     min-width: max-content !important;
    // }
    // ::v-deep .v-calendar-category__columns{
    //     // min-width:120px !important;
    //     // display:inline-block !important;
    //     width: max-content !important;
    //     min-width: max-content !important;
    // }
    // ::v-deep .v-calendar-category__column{
    //     // min-width:120px !important;
    //     // display:inline-block !important;
    //     width: max-content !important;
    //     min-width: max-content !important;
    // }
    // ::v-deep .v-event-timed-container{
    //     // min-width:120px !important;
    //     // display:inline-block !important;
    //     width: max-content !important;
    //     min-width: max-content !important;
    // }
    // ::v-deep .v-event-timed{
    //     // display: block !important;
    //     // min-width:120px !important;
    //     display:inline-block !important;
    //     width: max-content !important;
    //     min-width: max-content !important;
    // }

    ::v-deep .v-calendar .v-event-timed-container{
        margin-right: 0;
    }

    // ::v-deep .v-event-timed {

    // }
    
    .mit-space-header:hover {
        text-decoration: underline;
    }

    // this is for the calendar current time line
    .v-current-time {
      height: 3px;
      background-color: #ea4335;
      position: absolute;
      left: -1px;
      right: 0;
      pointer-events: none;

      // &.first::before {
      //   content: '';
      //   position: absolute;
      //   background-color: #ea4335;
      //   width: 12px;
      //   height: 12px;
      //   border-radius: 50%;
      //   margin-top: -5px;
      //   margin-left: -6.5px;
      // }
  }
  .potential-event {
    // border:2px solid #2c2b3b ;
    // border-radius: 5px;
    //border: 2px solid var(--v-primary-darken4);
    // border: 1px solid black;
  }
</style>
